module.exports = __webpack_public_path__ + "static/media/contact_bg_img.5d435f84.jpg";